
    import {Component, Vue} from 'vue-property-decorator'
    import {ServiceLineListDto} from "@/api/commonConfig";
    import {CompanyInfoDto, getCompanyDtl} from "@/api/customerManage";
    import {Getter} from "vuex-class";
    import ShareServiceLine from "@/views/share/template/ShareServiceLine.vue";

    @Component({
        name: 'ShareService',
        components: { ShareServiceLine }
    })
    export default class ShareService extends Vue {
        @Getter shareInfo!: any
        serviceLineList: ServiceLineListDto[] = []
        companyInfo: CompanyInfoDto | Record<string, any> = {}

        created() {
            this.getCompanyInfo()
        }

        getCompanyInfo() {
            getCompanyDtl({ companyId: this.shareInfo.shopId }).then(res => {
                this.companyInfo = res.data || {}
                this.serviceLineList = this.companyInfo.serviceLineList || []
            })
        }

        showServiceLine () {
            (this.$refs.serviceLine as any).show()
        }

        toRegister () {
            this.$router.push({
                path: '/shareRegister'
            })
        }

        toLogin () {
            this.$router.push({
                path: '/shareLogin'
            })
        }
    }
